window.slate = window.slate || {};
window.theme = window.theme || {};
var prodJsonArr2 = [];
var prodJsonArr1 = {};
var selValOrigLength = false;
var sections
var isColorClick = false
var isColorClickChk = false
var isSizeClick = false
var isSizeClickChk = false
var fireModal
/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
        var focusClass = 'js-focus-hidden';

        $element.first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);



        function callback() {
            $element.first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
        $('a[href*=#]').on('click', function(evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
        var eventName = options.eventNamespace ?
            'focusin.' + options.eventNamespace :
            'focusin';

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).on(eventName, function(evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
        var eventName = options.namespace ?
            'focusin.' + options.namespace :
            'focusin';

        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */
var cartSelectors = {
    total_discount: '[total-discount]',
    total_price: '[total-price]',
    line_price: '[indv-line-price]', //price of item x qty 
    price: '[indv-price]', //price of 1 of this item
    total_discount: '[indiv-savings]', //amount saved on this item
    total_items: '[total-items]',
    empty_cart_msg: '[empty-cart]'
};
slate.cart = {

    /* slate v1.0 import*/
    updateCartHtml: function(result) {
        //update items	
        result.items.forEach(function(entry, i) {
            $('[item-id-' + entry.id + '] ' + cartSelectors.line_price).html('$' + (entry.line_price / 100).toFixed(2));
            $('[item-id-' + entry.id + '] ' + cartSelectors.price).html('$' + (entry.price / 100).toFixed(2));
            $('[item-id-' + entry.id + '] ' + cartSelectors.total_discount).html('$' + (entry.total_discount / 100).toFixed(2));
        });
        //update cart totals
        $(cartSelectors.total_items).html(result.item_count);
        if (result.item_count == 0) {
            //cart is now empty	
            //hide cart content
            $(cartSelectors.empty_cart_msg).show();
            $('.page-cart form.cart').remove();
        } else {
            //update pricing	
            $(cartSelectors.total_price).html('$' + (result.total_price / 100).toFixed(2));
            $(cartSelectors.total_price).html('$' + (result.total_price / 100).toFixed(2));
            $(cartSelectors.total_discount).html('$' + (result.total_discount / 100).toFixed(2));
            if (typeof cartHookPull !== 'undefined') {
                if (typeof cartHookPull.callback !== 'undefined' && typeof cartHookPull.callback === 'function') {
                    cartHookPull.callback(result);
                }
            }
        }
    },
    getCart: function() {
        return $.getJSON('/cart.js');
    },
    updateNote: function(note) {
        return this._promiseChange({
            url: '/cart/update.js',
            dataType: 'json',
            data: {
                note: note || ''
            }
        });
    },
    addItem: function(id, quantity) {
        return this._promiseChange({
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id: id,
                quantity: typeof quantity === 'undefined' ? 1 : quantity
            }
        });
    },
    addItemFromForm: function(data) {
        return this._promiseChange({
            url: '/cart/add.js',
            dataType: 'json',
            data: data
        });
    },
    removeItem: function(id) {
        return this._promiseChange({
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: id,
                quantity: 0
            }
        });
    },
    changeItem: function(id, quantity) {
        var originalQuantity = parseInt(quantity, 10);
        var requestSettings = {
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: id,
                quantity: quantity
            }
        };

        return this._promiseChange(requestSettings);
    },
    saveLocalState: function(state) {
        slate.cart.updateCartHtml(state)
        if (slate.cart._isLocalStorageSupported()) {
            localStorage.shopify_cart_state = JSON.stringify(state); // eslint-disable-line camelcase
        }
        return state;
    },
    getLocalState: function() {
        // eslint-disable-line consistent-return
        if (slate.cart._isLocalStorageSupported()) {
            return JSON.parse(localStorage.shopify_cart_state || '');
        }
    },
    cookiesEnabled: function() {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }
        return cookieEnabled;
    },
    _promiseChange: function(parameters) {
        var _this = this;

        var promiseRequest = $.ajax(parameters);

        // If offline, provide a rejected promise so that an error is thrown.
        /*if (navigator && !theme.isOnline) {
            promiseRequest = $.Deferred().reject();
        }*/

        return promiseRequest
            // Some cart API requests don't return the cart object. If there is no
            // cart object then get one before proceeding.
            .then(function(state) {
                if (typeof state.token === 'undefined') {
                    return _this.getCart();
                } else {
                    return state;
                }
            }).then(this.saveLocalState);
    },
    _isLocalStorageSupported: function() {
        var mod = 'localStorageTest';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch (error) {
            return false;
        }
    }
    //end slate 1.0 import
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
    }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

    wrapTable: function() {
        $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
    },

    iframeReset: function() {
        var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
        var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

        $iframeVideo.each(function() {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="rte__video-wrapper"></div>');
        });

        $iframeReset.each(function() {
            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    }
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },

    _onSelect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(evt);
        }
    },

    register: function(type, constructor) {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(function(index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ',');
            decimal = slate.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            /*console.log(image)*/
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        if (src === undefined ) {
            return null; 
        }
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     * carl edit force progressive
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        /*console.log(src,size)*/
        if (size !== null) {
            if (size === 'master') {
                console.log('master')
                return this.removeProtocol(src);
            }
        }

        var match = src.match(/\.(progressive.png.jpg|jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
            /* console.log('match',match)*/
            var prefix = src.split(match[0]);
            var extN = match[1];
            var suffix = match[2];
            if (size === null) {
                // console.log(match)
                // return this.removeProtocol(prefix[0] +'.progressive.png.jpg'+ suffix);//force
                //return this.removeProtocol(prefix[0] +'.png'+ suffix);
                return this.removeProtocol(prefix[0] + '.' + extN + suffix);
            } else {
                return this.removeProtocol(prefix[0] + '_' + size + suffix);
            }
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

 slate.Variants = (function() {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    var prevAvailable = true
    var prodSku = false
    var skuDeluxM = '3001D'
    var skuLuxM = '3001HD'
    var skuDeluxF = 'DM104LD'
    var skuLuxF = '6070D'
    //new teelaunch skus
    var prodSku2 = false
   // var skuDeluxM2 = '3001'
    //var skuLuxM2 = '3001CVC'
   // var skuDeluxF2 = 'DM104L'
    var skuLuxF2 = '6710D'
    /*
    m00nshot7 
    mens delux 3001D
    mens lux 3001HD
    womens delux DM104LD
    womens lux 6070D
    */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function() {

            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');
                        currentOption.type = $element.data('optiontype');
                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');
                    currentOption.type = $element.data('optiontype');
                    return currentOption;
                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },


        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        //hide variants
        //hide unavailable options
        _hideOptions: function(selectedValues, variants) {
            //console.log("hiding options");
            //reset
            var formElm = $('#shopify-section-product, #shopify-section-product_multiswitcher, #shopify-section-product_multiswitcher_light').find('.prodFormElm');
            formElm.find('input[type="radio"]').parent().removeClass('isAvailable').removeClass('isNotAvailable').removeClass('isAvailable2');
            var styleSelect = false;
            var printSelect = false;
            var colorSelect  = false;
            var sizeSelect = false;
            var styleOptInd = false;
            var printOptInd  = false;
            var colorOptInd = false;
            var sizeOptInd = false;

            selectedValues.forEach(function(option, i) {
                //console.log('selected value',option,i)

                if (option.type == 'pflStyle' || option.type == 'tlnStyle'  || option.type == 'wlmStyle'  ) {
                    styleSelect = i;
                    styleOptInd = option.index;
                }
                if (option.type == 'print-location' || option.type == 'print-location' ) {
                    printSelect  = i;
                    printOptInd = option.index;
                }
                if (option.type == 'color' || option.type == 'Color'  ) {
                    colorSelect  = i;
                    colorOptInd = option.index;
                }
                if (option.type == 'size' || option.type == 'Size'   ) {
                    sizeSelect  = i;
                    sizeOptInd = option.index;
                }

                var theInd = i + 2
                var theRlInd = i
                //skip first option
                if (i > 1) {
                    //  formElm.find('.optionWrap2').removeClass('isAvailable');
                }
                if (i > 0) {
                    variants.forEach(function(theVarOp, i) {
                     var theVarOptIndColor = theVarOp.option1 //default
                        if ( colorOptInd == 'option2' ) {
                            theVarOptIndColor = theVarOp.option2
                        }
                        if ( colorOptInd == 'option3' ) {
                            theVarOptIndColor = theVarOp.option3
                        }
                        //spoof to heather
                        if(theVarOptIndColor == 'Ash') {
                            theVarOptIndColor = 'Heather Ash';
                        }
                        if(theVarOptIndColor == 'White Fleck Triblend') {
                            theVarOptIndColor = 'Heather White Fleck Triblend';
                        }
                        //greyed out  size selects
                       var colorElm = colorSelect;
                       //console.log(selectedValues[colorElm])
                       if(typeof selectedValues[colorElm]  === 'undefined' ) {
                        colorElm = colorSelect+1
                       } 
                        if(typeof  selectedValues[colorElm]  !== 'undefined') {
                            if (theVarOp.option1 == selectedValues[colorElm].value  ) {
                                var keyMatch = Object.keys(theVarOp)[colorSelect]; //fetched the key at fifth index  
                                // size line out
                                if (theVarOp['available'] == false) {
                                    formElm.find('input:radio[value="' + theVarOp[sizeOptInd] + '"]').parent().addClass('isGreyed');
                                } else {
                                    formElm.find('input:radio[value="' + theVarOp[sizeOptInd] + '"]').parent().removeClass('isGreyed');
                                }
                            }
                        };

                        if ($('#launchSwitcher').length) {
                            if (selectedValues[0].value == 'Womens' && (theVarOp.option1 == 'Womens Luxury T-Shirt' || theVarOp.option1 == 'M00nshot 6710' )) {
                                //console.log('woman lux')
                                formElm.find('input:radio[value="Luxury"]').parent().addClass('isAvailable');
                            }
                            if (selectedValues[0].value == 'Womens' && (theVarOp.option1 == 'Womens Deluxe T-Shirt' || theVarOp.option1 == 'M00nshot DM104L' )) {
                                //console.log('woman dlux')
                                formElm.find('input:radio[value="Deluxe"]').parent().addClass('isAvailable');
                            }
                            if (selectedValues[0].value == 'Mens' && (theVarOp.option1 == 'Mens Luxury T-Shirt' || theVarOp.option1 == 'M00nShot 3001cvc')) {
                                formElm.find('input:radio[value="Luxury"]').parent().addClass('isAvailable');
                            }
                            if (selectedValues[0].value == 'Mens' && (theVarOp.option1 == 'Mens Deluxe T-Shirt' || theVarOp.option1 == 'M00nshot 3001' )) {
                                formElm.find('input:radio[value="Deluxe"]').parent().addClass('isAvailable');
                            }
                        }

                        //end new
                        //if ($('#SingleOptionSelector-11-deluxe').length) { //maybe needs to come back?
                        if ($('#SingleOptionSelector-10-mens').length  ) {
                            //ghost options	
                            if (theVarOp.option1 == selectedValues[2].value && theRlInd == 1) {
                                var keyMatch = Object.keys(theVarOp)[theInd]; //fetched the key at fourth index		
                                formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isAvailable');
                            }
                            if (theVarOp.option1 == selectedValues[2].value && theVarOp.option2 == selectedValues[3].value && theRlInd == 2) {
                                var keyMatch = Object.keys(theVarOp)[theInd]; //fetched the key at fifth index  
                                // size line out
                                if (theVarOp['available'] == false) {
                                    formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isGreyed');
                                } else {
                                    formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().removeClass('isGreyed');
                                }
                                formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isAvailable');
                            }
                            if ($('#printSwitcher').length ) {
                                var unspoofedColor =  theVarOptIndColor
                                 if(unspoofedColor == 'Heather Ash') {
                                    unspoofedColor = 'Ash';
                                 }
                                 if(unspoofedColor == 'Heather White Fleck Triblend') {
                                    unspoofedColor = 'White Fleck Triblend';
                                 }
                                if ( theVarOptIndColor.indexOf('Heather') !== -1 && selectedValues[1].value == 'Luxury'  ) {
                                    formElm.find('input:radio[value="' + unspoofedColor + '"]').parent().removeClass('isNotAvailable');
                                } else  if ( theVarOptIndColor.indexOf('Heather') == -1 && selectedValues[1].value == 'Luxury'  ) {
                                    formElm.find('input:radio[value="' + unspoofedColor + '"]').parent().addClass('isNotAvailable');
                                } else  if ( theVarOptIndColor.indexOf('Heather') == -1 && selectedValues[1].value == 'Deluxe'  ) {
                                    formElm.find('input:radio[value="' + unspoofedColor + '"]').parent().removeClass('isNotAvailable');
                                } else  if (  theVarOptIndColor.indexOf('Heather') !== -1 && selectedValues[1].value == 'Deluxe'  ) {
                                    formElm.find('input:radio[value="' + unspoofedColor + '"]').parent().addClass('isNotAvailable');
                                }
                                if ( theVarOptIndColor.indexOf('Heather') !== -1   ) {
                                    formElm.find('input:radio[value="Deluxe"]').parent().addClass('isAvailable');
                                }
                                if ( theVarOptIndColor.indexOf('Heather') == -1 ) {
                                    formElm.find('input:radio[value="Luxury"]').parent().addClass('isAvailable');
                                }
                            }

                            } else if ( $('#tankTopSwitcher').length ) {
                           //ghost options	
                           if (theVarOp.option1 == selectedValues[1].value && theRlInd == 1) {
                              var keyMatch = Object.keys(theVarOp)[theInd]; //fetched the key at fourth index		
                               formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isAvailable');
                            }
                             if (theVarOp.option1 == selectedValues[1].value && theVarOp.option2 == selectedValues[2].value && theRlInd == 2) {
                                 var keyMatch = Object.keys(theVarOp)[theInd]; //fetched the key at fifth index  
                                 // size line out
                                 if (theVarOp['available'] == false) {
                                    formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isGreyed');
                                 } else {
                                     formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().removeClass('isGreyed');
                                 }
                                 formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isAvailable');
                          }
                            if ( theVarOp.option1.indexOf('Triblend') !== -1  && selectedValues[0].value == 'Luxury'  ) {
                                formElm.find('input:radio[value="' + theVarOp.option1 + '"]').parent().removeClass('isNotAvailable');
                            } else  if ( theVarOp.option1.indexOf('Triblend')  == -1 && selectedValues[0].value == 'Luxury'  ) {
                                formElm.find('input:radio[value="' + theVarOp.option1 + '"]').parent().addClass('isNotAvailable');
                            } else  if ( theVarOp.option1.indexOf('Triblend') == -1 && selectedValues[0].value == 'Deluxe'  ) {
                                formElm.find('input:radio[value="' + theVarOp.option1 + '"]').parent().removeClass('isNotAvailable');
                            } else  if ( theVarOp.option1.indexOf('Triblend') !== -1  && selectedValues[0].value == 'Deluxe'  ) {
                                formElm.find('input:radio[value="' + theVarOp.option1 + '"]').parent().addClass('isNotAvailable');
                            }
                            


                            if ( theVarOp.option1.indexOf('Triblend') !== -1 ) {
                                formElm.find('input:radio[value="Deluxe"]').parent().addClass('isAvailable');
                            }
                            if ( theVarOp.option1.indexOf('Triblend')  == -1  ) {
                                formElm.find('input:radio[value="Luxury"]').parent().addClass('isAvailable');
                            }
                            //ash problem
                            /*if ( theVarOp.option1.indexOf('Ash') !== -1  && selectedValues[0].value == 'Luxury'  ) {
                                formElm.find('input:radio[value="' + theVarOp.option1 + '"]').parent().removeClass('isNotAvailable');
                            } else  if ( theVarOp.option1.indexOf('Ash')  == -1 && selectedValues[0].value == 'Luxury'  ) {
                                formElm.find('input:radio[value="' + theVarOp.option1 + '"]').parent().addClass('isNotAvailable');
                            } else  if ( theVarOp.option1.indexOf('Ash') == -1 && selectedValues[0].value == 'Deluxe'  ) {
                                formElm.find('input:radio[value="' + theVarOp.option1 + '"]').parent().removeClass('isNotAvailable');
                            } else  if ( theVarOp.option1.indexOf('Ash') !== -1  && selectedValues[0].value == 'Deluxe'  ) {
                                formElm.find('input:radio[value="' + theVarOp.option1 + '"]').parent().addClass('isNotAvailable');
                            }

                            if ( theVarOp.option1.indexOf('Ash') !== -1 ) {
                                formElm.find('input:radio[value="Deluxe"]').parent().addClass('isAvailable');
                            }
                            if ( theVarOp.option1.indexOf('Ash')  == -1  ) {
                                formElm.find('input:radio[value="Luxury"]').parent().addClass('isAvailable');
                            }*/


                        } else if ( $('#pflLongSleeveSwitcher').length || $('#wlmLongSleeveSwitcher').length ) {
                            //ghost options	
                            if (theVarOp.option1 == selectedValues[1].value && theRlInd == 1) {
                               var keyMatch = Object.keys(theVarOp)[theInd]; //fetched the key at fourth index		
                               //console.log(theVarOp[keyMatch] ,'key1')	
                                formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isAvailable');
                             }
                              if (theVarOp.option1 == selectedValues[1].value && theVarOp.option2 == selectedValues[2].value && theRlInd == 2) {
                                  var keyMatch = Object.keys(theVarOp)[theInd]; //fetched the key at fifth index  
                                 // console.log(theVarOp[keyMatch] ,'key2')
                                  // size line out
                                  if (theVarOp['available'] == false) {
                                     formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isGreyed');
                                  } else {
                                      formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().removeClass('isGreyed');
                                  }
                                  formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isAvailable');
                           }

                             if ( theVarOptIndColor.indexOf('Heather') !== -1  && selectedValues[0].value == 'Luxury'  ) {
                                 formElm.find('input:radio[value="' + theVarOptIndColor + '"]').parent().removeClass('isNotAvailable');
                             } else  if ( theVarOptIndColor.indexOf('Heather')  == -1 && selectedValues[0].value == 'Luxury'  ) {
                                 formElm.find('input:radio[value="' + theVarOptIndColor + '"]').parent().addClass('isNotAvailable');
                             } else  if ( theVarOptIndColor.indexOf('Heather') == -1 && selectedValues[0].value == 'Deluxe'  ) {
                                 formElm.find('input:radio[value="' + theVarOptIndColor + '"]').parent().removeClass('isNotAvailable');
                             } else  if ( theVarOptIndColor.indexOf('Heather') !== -1  && selectedValues[0].value == 'Deluxe'  ) {
                                 formElm.find('input:radio[value="' + theVarOptIndColor + '"]').parent().addClass('isNotAvailable');
                             }
                             if ( theVarOptIndColor.indexOf('Heather') == -1 ) {
                                 formElm.find('input:radio[value="Deluxe"]').parent().addClass('isAvailable');
                             }
                             if ( theVarOptIndColor.indexOf('Heather')  !== -1 ) {
                                 formElm.find('input:radio[value="Luxury"]').parent().addClass('isAvailable');
                             }
                         } else {
                            //console.log('normal mode');
                            //normal
                            if (theVarOp.option1 == selectedValues[0].value && theRlInd == 1) {
                                var keyMatch = Object.keys(theVarOp)[theInd]; //fetched the key at fourth index
                                formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isAvailable');
                            }
                            if (theVarOp.option1 == selectedValues[0].value && theVarOp.option2 == selectedValues[1].value && theRlInd == 2) {
                                var keyMatch = Object.keys(theVarOp)[theInd]; //fetched the key at fifth index
                                formElm.find('input:radio[value="' + theVarOp[keyMatch] + '"]').parent().addClass('isAvailable');
                            }
                            
                        }

                    });
                }
            });
            //hide all with no showclass

            formElm.find('.selector-wrapper .optionWrap:not(.isAvailable, .optionWrap0)').addClass('isNotAvailable');
           formElm.find('.selector-wrapper .isAvailable').removeClass('isAvailable');
        },
        //get variants	
        _getVariantFromOptions: function() {
            //console.log('search variants from options');
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;
            var optCnt = selectedValues.length

            if ($('#launchSwitcher').length) {
                prodSku2 = false
                if ($('#SingleOptionSelector-11-deluxe:checked').length && $('#SingleOptionSelector-10-mens:checked').length) {
                    prodSku = skuDeluxM
                }
                if ($('#SingleOptionSelector-11-luxury:checked').length && $('#SingleOptionSelector-10-mens:checked').length) {
                    prodSku = skuLuxM
                }
                if ($('#SingleOptionSelector-11-deluxe:checked').length && $('#SingleOptionSelector-10-womens:checked').length) {
                    prodSku = skuDeluxF
                }
                if ($('#SingleOptionSelector-11-luxury:checked').length && $('#SingleOptionSelector-10-womens:checked').length) {
                    prodSku = skuLuxF
                    prodSku2 = skuLuxF2
                }
            }
            if ($('#printSwitcher').length ) {
                if($('#SingleOptionSelector-11-deluxe:checked').length && $('#SingleOptionSelector-10-mens:checked').length) {
                    prodSku = 'skuDeluxM';
                }
                if($('#SingleOptionSelector-11-luxury:checked').length && $('#SingleOptionSelector-10-mens:checked').length) {
                    prodSku = 'skuLuxM';
                }
            }
            
            if ( $('#tankTopSwitcher').length  || $('#pflLongSleeveSwitcher').length || $('#wlmLongSleeveSwitcher').length ) {
                if($('#SingleOptionSelector-11-deluxe:checked').length) {
                    prodSku = 'skuDeluxM';
                }
                if($('#SingleOptionSelector-11-luxury:checked').length) {
                    prodSku = 'skuLuxM';
                }
            }
          


            //old search loop
            function seachVariants(opt) {
                //console.log('searching variants');
                if (isColorClick) {
                    isColorClickChk = true;
                } else {
                    isColorClickChk = false;
                }
                if (isSizeClick) {
                    isSizeClickChk = true;
                } else {
                    isSizeClickChk = false;
                }
                var isLooking = true
                //no loop matcher
                //speedy variants search by carl (still needs sku /heather filter)
               if(opt == 3) { //only trigger if 3 variant set for bundle switch
                var selValLast = selectedValues.length - prodJsonArr1.options.length
                //console.log('sel val last',  prodJsonArr2[selectedValues[0+selValLast].value] );
                if (typeof(prodJsonArr2[selectedValues[0+selValLast].value]) !== "undefined") {
                    //run search if 1 option
                    if (prodJsonArr1.options.length == 1) {
                            found = (variants[prodJsonArr2[selectedValues[0+selValLast].value]['i']]);
                            elmFound = true
                            isLooking = false
                    }
                    if (typeof(prodJsonArr2[selectedValues[0+selValLast].value][selectedValues[1+selValLast].value]) !== "undefined") {
                        //run search if 2 options
                        if (prodJsonArr1.options.length == 2) {
                            found = (variants[prodJsonArr2[selectedValues[0+selValLast].value][selectedValues[1+selValLast].value]['i']]);
                            elmFound = true
                            isLooking = false
                        }
                    if (typeof(prodJsonArr2[selectedValues[0+selValLast].value][selectedValues[1+selValLast].value][selectedValues[2+selValLast].value]) !== "undefined") {
                            //run search if 3 options
                            found = (variants[prodJsonArr2[selectedValues[0+selValLast].value][selectedValues[1+selValLast].value][selectedValues[2+selValLast].value]['i']]);
                            elmFound = true
                            isLooking = false
                            console.log('fast search3');
                            console.log('fast search3 found', found );
                          }
                      }
              }
            }
          
              if (isLooking) {
                //console.log('still looking');
                variants.forEach(function(entry, i) {

                    var entryColor = entry.option1;
                    if( entry.option1 == 'Full Front' ||  entry.option1 == 'Back' || entry.option1 == 'Left Chest' || entry.option1 == 'Back & Left Chest'  ){
                        entryColor = entry.option2;
                   };
                    if (isLooking) {
                        //noob code
                        var elmFound = false
                        var isHeather = false;
                        if (entryColor.indexOf('Heather') !== -1 || entryColor.indexOf('Triblend') !== -1 || entryColor == "Ash"   ) {
                            isHeather = true;
                        }
                        if ($('#tankTopSwitcher').length && entryColor.indexOf('Heather') !== -1) {
                            isHeather = false;
                        }
                        if (prodSku) {
                            //teelaunch
                            if ($('#launchSwitcher').length) {

                                if (!elmFound && opt == 'sku1') {

                                    if ( (entry.sku.indexOf(prodSku) > -1  || entry.sku.indexOf(prodSku2) > -1 ) && entry.option2 == selectedValues[3].value && entry.option3 == selectedValues[4].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if ( (entry.sku.indexOf(prodSku) > -1  || entry.sku.indexOf(prodSku2) > -1 ) && entry.option3 == selectedValues[4].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku3') {
                                    if ( (entry.sku.indexOf(prodSku) > -1  || entry.sku.indexOf(prodSku2) > -1 ) && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }

                                if (!elmFound && opt == 'sku4') {
                                    if (entry.sku.indexOf(prodSku) > -1  || entry.sku.indexOf(prodSku2) > -1 ) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                            }
                            //printful
                            if ($('#printSwitcher').length && !($('[data-optiontype=print-location]').length)) {

                                if (!elmFound && opt == 'sku1') {
                                    if (isHeather && selectedValues[1].value == 'Luxury' && entry.option1 == selectedValues[2].value && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku1') {
                                    if (!isHeather && selectedValues[1].value == 'Deluxe' && entry.option1 == selectedValues[2].value && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if (isHeather && selectedValues[1].value == 'Luxury' && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if (!isHeather && selectedValues[1].value == 'Deluxe' && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }

                            }
                            //printful
                            if ($('[data-optiontype=print-location]').length && $('.wlMultiprintPrintSwitcher').length ) {

                                if (!elmFound && opt == 'sku0') {
                                    //console.log('ok looking3')
                                    if (isHeather && selectedValues[1].value == 'Luxury' && entry.option1 == selectedValues[2].value && entry.option2 == selectedValues[3].value && entry.option3 == selectedValues[4].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku0') {
                                    if (!isHeather && selectedValues[1].value == 'Deluxe' && entry.option1 == selectedValues[2].value && entry.option2 == selectedValues[3].value && entry.option3 == selectedValues[4].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku1') {
                                    if (isHeather && selectedValues[1].value == 'Luxury' && entry.option1 == selectedValues[2].value && entry.option3 == selectedValues[4].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku1') {
                                    if (!isHeather && selectedValues[1].value == 'Deluxe' && entry.option1 == selectedValues[2].value && entry.option3 == selectedValues[4].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku1') {
                                    if (isHeather && selectedValues[1].value == 'Luxury' && entry.option1 == selectedValues[2].value && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku1') {
                                    if (!isHeather && selectedValues[1].value == 'Deluxe' && entry.option1 == selectedValues[2].value && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if (isHeather && selectedValues[1].value == 'Luxury' && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if (!isHeather && selectedValues[1].value == 'Deluxe' && entry.option2 == selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }

                            }
                             //printful tank and long sleeve fake backprint (alt product)
                             if ( ($('#tankTopSwitcher').length || $('#pflLongSleeveSwitcher').length || $('#wlmLongSleeveSwitcher').length) && !($('[data-optiontype=print-location]').length)) {
                                if (!elmFound && opt == 'sku1') {

                                    if (isHeather && selectedValues[0].value == 'Luxury' && entry.option1 == selectedValues[1].value && entry.option2 == selectedValues[2].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku1') {
                                    if (!isHeather && selectedValues[0].value == 'Deluxe' && entry.option1 == selectedValues[1].value && entry.option2 == selectedValues[2].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if (isHeather && selectedValues[0].value == 'Luxury' && entry.option2 == selectedValues[2].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if (!isHeather && selectedValues[0].value == 'Deluxe' && entry.option2 == selectedValues[2].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                            }
                            //printful tank and long sleeve fake backprint (alt product)
                             if ( ($('#tankTopSwitcher').length || $('#pflLongSleeveSwitcher').length || $('#wlmLongSleeveSwitcher').length) && $('[data-optiontype=print-location]').length ) {
                                if (!elmFound && opt == 'sku0') {
                                    if (isHeather && selectedValues[0].value == 'Luxury' && entry.option1 == selectedValues[1].value && entry.option2 == selectedValues[2].value && entry.option3 == selectedValues[3].value  ) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku0') {
                                    if (!isHeather && selectedValues[0].value == 'Deluxe' && entry.option1 == selectedValues[1].value && entry.option2 == selectedValues[2].value && entry.option3 == selectedValues[3].value ) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku1') {
                                    if (isHeather && selectedValues[0].value == 'Luxury' && entry.option1 == selectedValues[1].value && entry.option3 == selectedValues[3].value ) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku1') {
                                    if (!isHeather && selectedValues[0].value == 'Deluxe' && entry.option1 == selectedValues[1].value && entry.option3== selectedValues[3].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if (isHeather && selectedValues[0].value == 'Luxury' && entry.option2 == selectedValues[2].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                                if (!elmFound && opt == 'sku2') {
                                    if (!isHeather && selectedValues[0].value == 'Deluxe' && entry.option2 == selectedValues[2].value) {
                                        found = (variants[i]);
                                        elmFound = true
                                        isLooking = false
                                        isColorClick = false
                                        isSizeClick = false
                                    }
                                }
                            }
                        } else {
                            //other products
                            if (!elmFound && opt == 3) {
                                //console.log('ok looking3')
                                if (entry.option1 == selectedValues[0].value && entry.option2 == selectedValues[1].value && entry.option3 == selectedValues[2].value) {
                                    found = (variants[i]);
                                    elmFound = true
                                    isLooking = false
                                }

                            }
                            //for tee size
                            if (!elmFound && opt == 2) {
                                //look for size match first
                                if (entry.option1 == selectedValues[0].value && entry.option3 == selectedValues[2].value) {
                                    found = (variants[i]);
                                    elmFound = true
                                    isLooking = false
                                }

                            }
                            if (!elmFound && opt == 2) {
                                //color
                                if (entry.option1 == selectedValues[0].value && entry.option2 == selectedValues[1].value) {
                                    found = (variants[i]);
                                    elmFound = true
                                    isLooking = false
                                }

                            }
                            if (!elmFound && opt == 1) {
                                //console.log('ok looking12')
                                if (entry.option1 == selectedValues[0].value && entry.option2 == selectedValues[1].value) {
                                    found = (variants[i]);
                                    elmFound = true
                                    isLooking = false
                                }
                            }
                            if (!elmFound && opt == 0) {
                                //console.log('ok looking0')
                                if (entry.option1 == selectedValues[0].value) {
                                    found = (variants[i]);
                                    elmFound = true
                                    isLooking = false
                                }
                            }
                        }
                    }
                });
                };
                //variant search looper
            }
            if (prodSku) {
                //console.log('running sku');
                if (!found && prodSku) {
                    seachVariants('sku0');
                }
                if (!found && prodSku) {
                    seachVariants('sku1');
                }
                /* if (!found && prodSku && isColorClick == false) {
                     seachVariants('sku2');
                 }*/
                if (!found && prodSku) {
                    seachVariants('sku2');
                }
                if ($('#launchSwitcher').length) {
                    if (!found && prodSku) {
                        seachVariants('sku3');
                    }
                    if (!found && prodSku) {
                        seachVariants('sku4');
                    }
                }
            } else {
                //console.log('running extra');
                if (!found && optCnt >= 3) {
                    seachVariants(3);
                }
                if (!found && optCnt == 3) {
                    $('#shopify-section-product, #shopify-section-product_multiswitcher, #shopify-section-product_multiswitcher_light').addClass('prevOptComboUnavail');
                }
                if (!found && optCnt >= 3) {
                    seachVariants(2);

                }
                if (!found && optCnt >= 2) {
                    seachVariants(1);

                }
                if (!found && optCnt >= 1) {
                    seachVariants(0);

                }
                //screw it let's go with whatever we find on first option if any
                if (!found && selectedValues.length > 0) {
                    var firstVal = selectedValues[0].value;
                }

            }
            //console.log('found or not', found);
            this._hideOptions(selectedValues, variants);
            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function() {
            $('#shopify-section-product, #shopify-section-product_multiswitcher, #shopify-section-product_multiswitcher_light').removeClass('prevOptComboUnavail');
            var variant = this._getVariantFromOptions();
            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });
            if (!variant) {
                return;
            }

            //console.log(variant)

            // Select			
            var selector = this.originalSelectorId;
            $('.iWishAdd').attr('data-variant', variant.id);
            if (variant) {
                var form = $('#shopify-section-product, #shopify-section-product_multiswitcher, #shopify-section-product_multiswitcher_light').find('form');
                for (var i = 0, length = variant.options.length; i < length; i++) {
                    /*console.log('option' + i, ' ' + variant.options[i]);*/
                    var theSelVal = variant.options[i]
                    theSelVal = theSelVal.replace(/\"/g, '&quote; ')
                    var select0r = form.find('select option[value="' + theSelVal + '"]:not(:selected)');
                    //console.log(theSelVal)

                    if (select0r.length) {
                        select0r.get(0).selected = true;
                        select0r.parent().trigger('change');
                        $('#shopify-section-product, #shopify-section-product_multiswitcher, #shopify-section-product_multiswitcher_light').addClass('prevOptComboUnavail');
                    }
                }
            }
            // RADIO SWATCHES			
            //var selector = this.originalSelectorId;
            if (variant) {
                var form = $('#shopify-section-product, #shopify-section-product_multiswitcher, #shopify-section-product_multiswitcher_light').find('form');
                for (var i = 0, length = variant.options.length; i < length; i++) {
                    /*console.log('option' + i, ' ' + variant.options[i]);*/
                    var theRadVal = variant.options[i]
                    theRadVal = theRadVal.replace(/\"/g, '&quote; ')
                    var radioButton = form.find('input:radio[name="SingleOptionSelector-'+i+'"][value="' + theRadVal + '"]:not(:checked)');
                     console.log('re-selecting, can trigger infinite loops');
                    if (radioButton.length) {
                        radioButton.get(0).checked = true;
                        //radioButton.get(0).parent().addClass('isChecked')
                        isColorClick = false
                        isSizeClick = false
                        radioButton.trigger('change');
                        $('#shopify-section-product, #shopify-section-product_multiswitcher, #shopify-section-product_multiswitcher_light').addClass('prevOptComboUnavail');
                    }
                }
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
            this._hideOptions(this._getCurrentOptions(), this.product.variants)

        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function(variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function(variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param {object} variant - Currently selected variant
         */
        _updateHistoryState: function(variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({
                path: newurl
            }, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param {object} variant - Currently selected variant
         */
        _updateMasterSelect: function(variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePercent: '[data-percent-price]',
        compareSaved: '[data-amount-saved]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
    };


    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        this.settings = {};
        this.namespace = '.product';

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!prodJsonArr1) {
            return;
        }

        this.productSingleObject = prodJsonArr1 //JSON.parse($(prodJsonArr1, this.$container).html());
        this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

        slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
             //quick mapper by carl
    var newItm1 = ''; 
    var newItm2 = ''; 
    var newItm3 = ''; 
    
    prodJsonArr1.variants.forEach( function(arrItm, i ){
        var arrApdg = { i, sku: prodJsonArr1.variants[i].sku, available: prodJsonArr1.variants[i].available }; 
        if (prodJsonArr1.options.length > 0)  {
        if ( newItm1 != prodJsonArr1.variants[i].option1 ) {
          newItm1  = prodJsonArr1.variants[i].option1; 
          if (prodJsonArr1.options.length == 1)  {
              prodJsonArr2[newItm1]  = arrApdg;
          } else { 
            prodJsonArr2[newItm1] = {};
          }
        };
        }
        if (prodJsonArr1.options.length > 1 ) {
        if ( newItm2 != prodJsonArr1.variants[i].option2 ) {
          newItm2  = prodJsonArr1.variants[i].option2; 
          if (prodJsonArr1.options.length == 2)  {
              prodJsonArr2[newItm1][newItm2]  = arrApdg;
          } else { 
             prodJsonArr2[newItm1][newItm2]  = {};
          }
        };
      }
      if (prodJsonArr1.options.length > 2 ) {
        if ( newItm3 != prodJsonArr1.variants[i].option3 ) {
          newItm3  = prodJsonArr1.variants[i].option3; 
          if (prodJsonArr1.options.length == 3)  {
          if (typeof prodJsonArr2[newItm1][newItm2] === 'undefined' )  {
              prodJsonArr2[newItm1][newItm2] = {};
          }
          if(prodJsonArr2[newItm1][newItm2])
              prodJsonArr2[newItm1][newItm2][newItm3]  = arrApdg;
          } else {
            prodJsonArr2[newItm1][newItm2][newItm3]  = {};
          }
        }; 
      }
    });

        this.initVariants();
    }

    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Handles change events from the variant inputs
         */
        initVariants: function() {
            var options = {
                $container: this.$container,
                enableHistoryState: this.$container.data('enable-history-state') || false,
                singleOptionSelector: selectors.singleOptionSelector,
                originalSelectorId: selectors.originalSelectorId,
                product: this.productSingleObject
            };

            this.variants = new slate.Variants(options);
            this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
            this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
            this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
        },

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabeled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt) {
            var variant = evt.variant;
            console.log(variant + 'VARIANT');
            //console.log(variant.option2);
            //$('.colorCheck').hide();
            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart); //add to cart html

            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                //sold out if color 
                if (isColorClickChk) {
                    $(selectors.addToCartText, this.$container).html("COLOR SOLD OUT");
                    if (variant.option2 == 'Vintage Black') {
                        //$('.colorCheck').show();
                    }
                } else if (isSizeClickChk) {
                    //sold out size (wanted  color for all so..)
                    $(selectors.addToCartText, this.$container).html("COLOR SOLD OUT");
                    if (variant.option2 == 'Vintage Black') {
                       // $('.colorCheck').show();
                    }
                } else {
                    //$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
                    //if(variant.option1.indexOf('T-Shirt') !== -1) {
                    $(selectors.addToCartText, this.$container).html('COLOR SOLD OUT');
                    if (variant.option2 == 'Vintage Black') {
                       // $('.colorCheck').show();
                    }
                    //} else {
                    //$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
                    //}
                }
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $(selectors.comparePriceText, this.$container);
            var $comparePercent = $(selectors.comparePercent, this.$container);
            var $compareSaved = $(selectors.compareSaved, this.$container);
            $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $comparePrice.removeClass('hide');
                $compareEls.removeClass('hide');
                $comparePercent.removeClass('hide');
                var percentOff = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
                console.log(variant.compare_at_price)
                console.log(variant.price)
                //current_variant.compare_at_price | minus: current_variant.price | times: 100.0 | divided_by: current_variant.compare_at_price | round 
                $comparePercent.html('<span class="save">' + percentOff + '% </span');
                $compareSaved.html(slate.Currency.formatMoney(variant.compare_at_price - variant.price, theme.moneyFormat));
            } else {
                $comparePrice.html('');
                $comparePrice.addClass('hide');
                $compareEls.addClass('hide');
                $comparePercent.addClass('hide');
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function(evt) {
            var variant = evt.variant;
            var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
            $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {
                parameters: {
                    _method: 'delete'
                }
            });
        }
    });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
    var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length) {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
            return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }
})();

/*url search param*/
function getUrlParameter(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return false;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/* 
////
//// ON DOC READY
////
--------------------------------------------------------------*/
var captchaSet 
var captchaValid 
$(document).ready(function() {
    sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));
    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Wrap videos in div to force responsive layout.
    slate.rte.wrapTable();
    slate.rte.iframeReset();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }
    //if  cart ajax is turned on
    //update cart html
    if (typeof cartAsAjax !== "undefined") {
        if (cartAsAjax) {
            //if ajax cart
            function updateCartHtml() {
                var theCart = slate.cart.getCart()
            }
            //cart remove item
            $('.cartRemove').on('click', function(e) {
                e.preventDefault();
                var theId = $(this).attr('data-id');
                theCart = slate.cart.removeItem(theId);
                $('.cart-row[item-id-' + theId + '], .responsive-table-row[item-id-' + theId + ']').remove();
                updateCartHtml();
            });
            //update item
            function updateItm(theItm) {
                var theId = theItm.attr('data-id');
                var theQty = theItm.val();
                if (theQty > 0) {
                    theCart = slate.cart.changeItem(theId, theQty);
                    //updateCartHtml();
                } else {
                    theItm.val(1);
                }
            }
            $('.cartQty').on('keyup change', function(e) {
                updateItm($(this))
            });
            //+ and -
            $('.cart-row .items ').on('click', function(e) {
                updateItm($(this).parent().children('.cartQty'))
            });
            //size update
            
           $('[data-prod-id-size-sel]').on('change', function(e) {
                var thisSel  =  $(this)
                var variantNewSize = ''  //maybe pull  on change vs response
                var newVariantId =  thisSel.val();
                var selHtml = thisSel.html();
                var variantId = thisSel.attr('data-variant-id');
                var prodCount = $('input[data-id='+variantId+']').val();
                var oldPrice = $('[total-price]').html();
                console.log(prodCount);
                var theRepEl = $('.cart-row[item-id-' + variantId + ']');
                theRepEl.removeAttr('item-id-' + variantId);
                theRepEl.attr('item-id-' + newVariantId,'');
                theRepEl.find('.cartQty').attr('id','updates_1234');
                theRepEl.find('.cartQty').attr('data-id',newVariantId);
               // updateCartHtml();
                //$('.cart-row[item-id-' + variantId + ']').empty();
                //$('.cart-row[item-id-' + variantId + ']').removeAttr('item-id-' + variantId).attr('item-id-' + newVariantId,'');
                
               slate.cart.addItem(newVariantId,prodCount).done((data) => {
                     
                    data.items.forEach(function(entry, i) {
                     //console.log(entry.vendor)
                      if(entry.id  ==  newVariantId) { 
                      var itemKey = entry.key
                         theRepEl.removeAttr('item-id-' + variantId);
                         theRepEl.attr('item-id-' + newVariantId,'');
                         theRepEl.find('a').attr('href', entry.url );
                        thisSel.attr('data-variant-id', newVariantId );
                        $('[item-id-' + entry.id + '] ' + cartSelectors.line_price).html('$' + (entry.line_price / 100).toFixed(2));
                        $('[item-id-' + entry.id + '] ' + cartSelectors.price).html('$' + (entry.price / 100).toFixed(2));

                        $('[item-id-' + entry.id + '] ' + cartSelectors.total_discount).html('$' + (entry.total_discount / 100).toFixed(2));
                        if (entry.total_discount) { 
                            theRepEl.find('.line-total, .mobilePrice').html('<span class="applied">Discount Applied:</span><s>$'+(item.original_line_price / 100).toFixed(2)+'</s><span class="genGrn" >&nbsp; $'+(item.final_line_price / 100).toFixed(2)+'<br><span class="genRd">You Save $'+(entry.total_discount / 100).toFixed(2)+'</span></span>');

                        } else {
                            //no discount
                            theRepEl.find('.line-total').html('$' + (entry.line_price / 100).toFixed(2));
                            theRepEl.find('.mobilePrice').html('$' + (entry.line_price / 100).toFixed(2));
                        }

                        //thisSel.find('option').removeAttr('selected').filter('[value='+newVariantId+']').attr('selected', true);
                        theRepEl.find('.cartRemove').attr('data-id',newVariantId);
                        // add subtract html
                        //theRepEl.find('.quantity-selector').html('<div class="reduced items genBtn1 ElmCirc  " onclick="var result = document.getElementById(\'updates_'+itemKey+'\'); var qty = result.value; if( !isNaN( qty ) &amp;&amp; qty > 1 ) result.value--; return false;"><i class="fa fa-minus"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg></i></div><input type="tel" name="updates[]" id="updates_'+itemKey+'" class="cartQty inputHasVal" value="1" min="0" data-id="'+newVariantId+'" aria-label="Item quantity"><div class="increase items genBtn1 ElmCirc  " onclick="var result = document.getElementById(\'updates_'+itemKey+'\'); var qty = result.value; if( !isNaN( qty )) result.value++;return false;"><i class="fa fa-plus"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg></i></div>');
                        theRepEl.find('input.cartQty').attr('id', 'updates_'+itemKey);
                        theRepEl.find('input.cartQty').attr('data-id', newVariantId);
                        //theRepEl.find('.reduced')
                        //theRepEl.find('.increase')
                        entry.options_with_values.forEach(function(optionEntry, i) {
                         //set default value
                         if (optionEntry.name == 'Size') {
                            variantNewSize = optionEntry.value;
                            theRepEl.attr('data-size',variantNewSize);
                         }
                         });
                         var fullSizeWord = variantNewSize; 
                         if(variantNewSize == 'S') {
                            fullSizeWord = 'Small';
                         } else if (variantNewSize == 'M') {
                            fullSizeWord = "Medium";
                         } else if (variantNewSize == 'L') {
                            fullSizeWord = "Large";
                        } 
                        $('.row .changed').remove();
                         thisSel.after('<span class="changed">Your size has been updated to <strong>'+fullSizeWord+'</strong>.</span>');
                         setTimeout(function(){ $('.row .changed').fadeOut(500,function(){
                            $('.row .changed').remove();
                         })},4500);
                      }
                   
                 });
                 //move to line item row maybe
                 // show small warning
                 if($(".row[data-size='S']").length){
                    $('.cartSmallWarn').show();
                 } else {
                    $('.cartSmallWarn').hide();
                 };
                 $('[total-price]').html(oldPrice);
                slate.cart.removeItem(variantId).done((data) => { });
                //updateCartHtml();
                });
                     
        });
           

        } else {
            //if not ajax cart

        }
    }
    // on scroll mod nav
    var notSet = true
    var searchOpen = false
    $(window).on("scroll", function(e) {
        if (searchOpen) {
            $('#mainNav #Search').trigger('blur');
        }
        if ($(window).scrollTop() > 1 && notSet) {
            $('body').addClass('scrolling');
            notSet = false
        } else if ($(window).scrollTop() <= 1) {
            $('body').removeClass('scrolling');
            notSet = true
        }
    });
    if ($(window).scrollTop() > 4) {
        $('body').addClass('scrolling');
    }
    //mobile menu toggle
    // menu toggle 
     //mobile menu toggle
    // menu toggle 
    $('.nav-hamburger, #mainNav  svg.icon-close').on('touchstart click', function(e) {
        if (event.handled === false) return
        e.preventDefault();
        e.stopPropagation();
        event.handled = true;
        $('body').toggleClass('menuOpen');
        $('.subnavOpen').removeClass('subnavOpen');
    });
    //submenu toggles 
    $('.site-nav--has-submenu a:not(.site-nav__submenu a, .sitenav_back__link a), .site-nav--has-submenu2nd a:not(.site-nav__submenu2nd a, .sitenav_back__link a) ').on('touchstart click', function(e) {
        console.log('gg')
        console.log(window.outerWidth)
        console.log(window.innerWidth)
        
        if (window.innerWidth < 1210) {
            if (event.handled === false) return
            e.preventDefault();
            e.stopPropagation();
            event.handled = true;
            $(this).parent().toggleClass('subnavOpen');
        }
    });
    //submenu toggles 
    $('.sitenav_back__link ').on('touchstart click', function(e) {
        if (window.innerWidth < 1210) {
            if (event.handled === false) return
            e.preventDefault();
            e.stopPropagation();
            event.handled = true;
            $(this).parent().parent().toggleClass('subnavOpen');
        }
    });
    //desktop menu
    var menuHeight
    var mouseIsOut = true

    function closeDskMenu(theEl) {
        if (window.innerWidth > 1209) {
            //wait a few in case going to a new item 
            setTimeout(function() {
                if (mouseIsOut) {
                    $('.site-nav .active').removeClass('active');
                    $('body').removeClass('dskMenuFade');
                    theEl.removeClass('fadeIt');
                    $('body').removeClass('dskMenuOpen');
                    $('.menuBg').height(0);
                }
            }, 2);
        }
    }
    //close menu when hovering other elements
    $('#mainHdrRgt,  #mainLogo').on('mouseenter', function() {
        if ($('#mainNav .active').length) {
            closeDskMenu($('#mainNav .active'));
        }
    });
    var theHoverElm

    function getmenuHeights() {
        $('.site-nav__submenu').each(function() {
            var outter = $(this).css({
                'opacity': '0',
                'display': 'flex'
            }).outerHeight();
            $(this).removeAttr('style');
            $(this).attr('data-height', outter);
        });
    }
    getmenuHeights();
    $('.site-nav--has-submenu').on('mouseenter', function() {
        if (window.innerWidth > 1209) {
            getmenuHeights();
            $('.site-nav .active').removeClass('active').removeClass('fadeIt');
            theHoverElm = $(this);
            theHoverElm.addClass('active');
            menuHeight = $(theHoverElm).find('.site-nav__submenu').attr('data-height');
            $('body').addClass('dskMenuOpen dskMenuFade');
            $('.menuBg').height(menuHeight);
            theHoverElm.addClass('fadeIt');
        };
    });
    $('.site-nav--has-submenu').on('mouseleave', function() {
        mouseIsOut = true
    });
    $('#mainNav .site-nav').on('mouseleave', function() {
        if ($('#mainNav .active').length) {
            closeDskMenu(theHoverElm);
        }
    });
    $('.no-submenu').on('mouseenter', function() {
        if ($('#mainNav .active').length) {
            closeDskMenu(theHoverElm);
        }
    });
    /* Buttons active mobile */
    $('body').on('touchstart', 'a, .genBtn1', function() {
        if ($(this).is('input', 'button')) {
            $(this).parent().addClass('active');
        } else {
            $(this).addClass('active');
        };
    });
    $('body').on('touchend', 'a, genBtn1', function() {
        if ($(this).is('input', 'button')) {
            $(this).parent().removeClass('active');
        } else {
            $(this).removeClass('active');
        };
    });
    /* nav profile hover */
    $('#mainHdrRgt li.profile').on(' mouseenter', function() {
        if ($(window).width() > 1209) {
            openMenuClear();
            var theMn = $(this)
            $(theMn).addClass('openProfMenu');
            setTimeout(function() {
                $(theMn).addClass('hover');
            }, 10);
        }
    });
    $('#mainHdrRgt li.profile').on(' mouseleave', function() {
        if ($(window).width() > 1209) {
            $(this).removeClass('hover');
            openMenuClose();
        }
    });
    $('#mainHdrRgt li.profile').on('click', function() {
        if ($(window).width() < 1210) {
            if ($(this).is('.openProfMenu')) {
                $(this).removeClass('hover');
                openMenuClose();
            } else {
                openMenuClear();
                var theMn = $(this)
                $(theMn).addClass('openProfMenu');
                setTimeout(function() {
                    $(theMn).addClass('hover');
                }, 10);
            }
        }
    });
    var openMenuLag;

    function openMenuClose() {
        openMenuLag = setTimeout(function() {
            $('.openProfMenu').removeClass('openProfMenu');
        }, 400);
    }

    function openMenuClear() {
        clearTimeout(openMenuLag);
    }
    //mainNav search
    function initNavSearch() {
        if (window.innerWidth > 1209) {
            $('#mainNav #Search').on('focus', function() {
                $('.searchWrp').addClass('searchWrpOpen');
                searchOpen = true
            });
            $('#mainNav #Search').on('blur', function() {
                setTimeout(function() {
                    $('.searchWrp').removeClass('searchWrpOpen');
                    searchOpen = false
                }, 200);
            });
        }
    }
    $('#mainNav #Search').trigger('blur');
    initNavSearch();
    $(window).on('resize', function() {
        initNavSearch();
    });
    //ratings submit button
    setTimeout(function() {
        $('.jdgm-widget input.btn').wrap('<span class="genBtn1"></span>');
    }, 800)
    //finding out wich select was clicked
    $('.select-color input[type=radio]').on('click', function() {
        isColorClick = true
    });

    //Modal/lightbox Trigger

    var theCurModal //to target currently opened modal theCurModal.close();
    var theModal
    var theLoc
    if ($('[data-lbox]').length) {
        fireModal = function(theUrl) {
            theModal = theUrl.replace(/.html/, '');
            theModal = theModal.replace(/.jpg/, '');
            theModal = theModal.replace(/.jpeg/, '');
            theModal = theModal.replace(/.png/, '');
            theModal = theModal.replace(/\//, '');
            theModal = theModal.replace(/\//, '');
            $('.remodal-wrapper .closeMob, .remodal-overlay .closeDesk').remove();
            $('.fullImgWrp').removeClass('fullImgWrp');
            $(".lBboxWrp").empty();
            if (theUrl.toLowerCase().match(/\.(jpg|png|gif)/g)) {
                function appendImage(theImage) {
                    var theWidth = theImage.width;
                    $(".lBboxWrp").append(theImage);
                    $(".lBboxWrp img").css({
                        'max-width': '100%',
                        'max-height': '100%'
                    })

                    theCurModal = $('.lBboxWrp').remodal();
                    $('.remodal-wrapper').prepend('<a href="#" class="closeDesk circ" data-remodal-action="close" ></a>');
                    
                    $('.lBboxWrp').addClass('lboxBG').addClass(theModal);
                    if(('#shopify-section-product_canvas').length) {
                        $('.remodal-wrapper, .remodal-overlay').addClass('fullImgWrp');
                        $('.lBboxWrp').addClass('lboxBG').addClass('imgModal');
                    }
                    $(".lBboxWrp").prepend('<span class="closeMob icon-mega-1" data-remodal-action="close"></span>');
                    $(".lBboxWrp").css({
                        'max-width': theWidth + "px",
                        'max-height': '100%'
                    })
                    theCurModal.open();
                }

                //create image to preload:
                var imgPreload = new Image();
                $(imgPreload).attr({
                    src: theUrl
                });

                //check if the image is already loaded (cached):
                if (imgPreload.complete || imgPreload.readyState === 4) {
                    appendImage(imgPreload);
                } else {
                    //go fetch the image:
                    $(imgPreload).load(function(response, status, xhr) {
                        if (status == 'error') {
                            //image could not be loaded:
                        } else {
                            appendImage(imgPreload);
                        }
                    });
                }
            } else {

                $(".lBboxWrp").load(theUrl + " #lboxCont", function() {
                    theCurModal = $('.lBboxWrp').remodal();
                    $('.remodal-wrapper').prepend('<a href="#" class="closeDesk circ" data-remodal-action="close" ></a>');
                    $('.lBboxWrp').addClass('lboxBG').addClass(theModal);
                    $(".lBboxWrp").prepend('<span class="closeMob icon-mega-1" data-remodal-action="close"></span>');
                    theCurModal.open();
                });
            }
        };
        $('body').prepend('<div id="lBox"><div class="lBboxWrp"></div></div>');
        $('[data-lbox]').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            var modalUrl = $(this).data('lbox');
            fireModal(modalUrl);
        });
        //listener to remove differential class		
        $(document).on('closed', '.remodal', function(e) {
            $(".lBboxWrp").removeClass(theModal);
            $(".lBboxWrp").removeAttr('style');
            $('.remodal-wrapper .closeDesk').remove();
        });
        //mobile bottom close link
        $(document).on('touchstart click', '.closeModal', function(e) {
            e.stopPropagation();
            e.preventDefault();
            theCurModal.close();
        });
    }
    //touch dropdown primary link disable
    $('.touchevents .site-nav--has-submenu  .sitenav_prim__link, .touchevents .site-nav--has-submenu2nd  .sitenav_prim__link').on('touchstart click', function(e) {
        e.stopPropagation();
        e.preventDefault();
    });


    //product tabs (canvas alt layout)
    $('#prodTabsHead a').on('click', function(e){
        e.preventDefault();
        if (!$(this).is('.cur')){
            var oldElm = $('#podTabsWrp .tab:visible');
            var newElm = $(this).attr('href');
            $("div"+newElm).css({'opacity':'0', 'position' : 'absolute', 'display': 'block' });
            var newHeight = $(newElm +" .tabCont" ).outerHeight();
            console.log(newHeight);
            
            //set tab height
            $('#podTabsWrp').height($('#podTabsWrp').outerHeight());    
            $(oldElm).css('position', 'absolute' ).animate({ opacity: 0 }, 250, function(){
                $(oldElm).css('display','none');
            });
            $('#podTabsWrp').animate({ height: newHeight }, 250 );
            $("div"+newElm).css({'position' : 'static' }).animate({ opacity: 1 }, 250, function(){
                $('#podTabsWrp').css('height', 'auto' );
            });
            $('#prodTabsHead a.cur').removeClass('cur');
            $(this).addClass('cur');
        }
    });
    //product enlarge
    $('.prodImgTmb[data-lightbox] ').on('click', function() {
        if($(window).width() > 841 && $('.enlargePreloaded').length ) {
            var lBoxUrl = $(this).attr('data-lightbox');
            fireModal(lBoxUrl,false);
        }
    });





    //check if accordion


    //old accordion
    /* var accords = []
     var offSetter = 0
     //get  open
     function checkAccordion() {
         //clear
         accords = []
         offSetter = 0
         $(".accordion ").each(function () {
             var topOffset = $(this).offset().top
             topOffset = topOffset - offSetter
             accords.push(topOffset);
             if ($(this).is('.accordion-open')) {
                 offSetter = $(".accordion-open").next('.container').outerHeight();
             }
         });
     }
     if ($(".accordion").length) {
         $('.accordion:not(#section1)').addClass('accordion-close');
         $('#section1').addClass('accordion-open');
         $('.accordion:not(#section1)').next('.container').hide();
         checkAccordion();
         $(window).resize(function () {
             checkAccordion();
         });
         $(".innerCont").on('click', '.accordion-open', function () {
             console.log('closing')
             $(this).next('.container').slideUp(600);
             $(this).removeClass('accordion-open').addClass('accordion-close');
         });
         $(".innerCont").on('click', '.accordion-close', function () {
             console.log('opening')

             console.log(accords);
             $('.container:visible').slideUp(600);
             $('.accordion-open').removeClass('accordion-open').addClass('accordion-close');
             $(this).removeClass('accordion-close').addClass('accordion-open');
             $(this).next('.container').slideDown(600);
             //scroll
             var theId = parseInt($(this).attr('id').replace('section', ''));
             var theHoff = accords[theId - 1] - 120
             $('html').animate({
                 scrollTop: theHoff
             }, 600)
         });
     }*/
    // new accordion staying open
    if ($(".accordion").length) {
        $('.accordion').addClass('accordion-close');
        $('.accordion').next('.container').hide();
        //close
        $(".innerCont").on('click', '.accordion-open', function() {
            $(this).removeClass('accordion-open').addClass('accordion-close');
            $(this).next('.container').slideUp(0);
        });
        //open
        $(".innerCont").on('click', '.accordion-close', function() {
            $(this).removeClass('accordion-close').addClass('accordion-open');
            $(this).next('.container').slideDown(0);
        });

    }
    //show hide luxury female
    $('.select-style input[name=SingleOptionSelector-0] ').on('change', function() {
        if ($('.select-style input[name=SingleOptionSelector-0]:checked').val() == 'Mens Deluxe T-Shirt') {
            $('.luxMsg').html('<span class="genC1">Note:</span> Athletic Fit. Order 1 size up for traditional/looser fit. ');
            $('.luxMsg').show();
        } else if ($('.select-style input[name=SingleOptionSelector-0]:checked').val() == 'Mens Luxury T-Shirt') {
            $('.luxMsg').html('<span class="genC1">Note:</span> Athletic Fit. Order 1 size up for traditional/looser fit. ');
            $('.luxMsg').show();
        } else if ($('.select-style input[name=SingleOptionSelector-0]:checked').val() == 'Womens Deluxe T-Shirt') {
            //$('.luxMsg').html('<span class="genC1">Note:</span> Women\'s luxury style runs small. Order 2 sizes up for standard fit.');
            $('.luxMsg').hide();
        } else if ($('.select-style input[name=SingleOptionSelector-0]:checked').val() == 'Womens Luxury T-Shirt') {
            $('.luxMsg').html('<span class="genC1">Note:</span> Women\'s luxury style runs small. Order 2 sizes up for standard fit. ');
            $('.luxMsg').show();
        } else {
            $('.luxMsg').hide();
        };
    });
    //add to cart pinterest
    /*
     $('#prodOptionBlock').on('click', '.btn[name=add]', function(){
        if (typeof pintrk !== "undefined") { 
            pintrk('track',  'addtocart');
        }
     });*/
    // newsearch
    // search toggle 
    $('.mobSearch').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('searchOpen');
    });
    $('#mainHdrSearch .btn').on('touchstart', function(e) {
        $('body').removeClass('searchOpen');
    });
    //inputs
    $('body').on('focus', 'input, textarea', function() {
        $(this).addClass('inputFocused');
    });
    $('body').on('focusout', 'input, textarea', function() {
        if ($(this).val() == '') {
            $(this).removeClass('inputFocused');
        }
    });
    $('body').on('blur', 'input, textarea', function() {
        //if ($(this).val() == '') {
        $(this).removeClass('inputFocused');
        //}
    });
    $('body').on('change', 'input, textarea', function() {
        if ($(this).val() == '') {
            $(this).removeClass('inputHasVal');
        } else {
            $(this).addClass('inputHasVal');
        }
    });
    $('body').on('keyup', 'input, textarea', function() {
        if ($(this).val() != '') {
            $(this).addClass('inputHasVal');
        }
    });
    $('input, textarea').each(function() {
        //console.log('fillval', $(this).attr('name'), $(this).val())
        if ($(this).val() != '') {
            $(this).addClass('inputHasVal');
        }
    });


    //account quick tabs
    $('#accountTabs a').on('click', function(e) {
        e.preventDefault();
        if (!$(this).is('.cur')) {
            $('#accountTabs a').removeClass('cur')
            $(this).addClass('cur');
            var theTab = $(this).attr('href');
            $('#tabCont .tab').hide();
            $("#tabCont " + theTab + "").show();
        }
    });
    $('.addressRow .editAdd, .editCancel ').on('click', function(e) {
        e.preventDefault();
        var editForm = $(this).attr('data-edit');
        $('#' + editForm).slideToggle('300');
        $('a.addAddress').show();
    });
    $('a.addAddress').on('click', function(e) {
        e.preventDefault();
        $('#AddressNewForm').slideDown('300');
        $(this).slideUp();
    });
    $('a.delete').on('click', function(e) {
        e.preventDefault();
        $(this).parent().children('form').submit();
    });
    $('a.passUpdate').on('click', function(e) {
        e.preventDefault();
        $('.form-reset-password').show();
    });

    var tmpImg = new Image();
    if ($('#prodContImgFeat [data-product-featured-image]').length) {
        tmpImg.src = $('#prodContImgFeat [data-product-featured-image]').attr('src');
        tmpImg.onload = function() {
            $('.load-wrapper').hide();
        };
    }
    /*$('#prodContDtls .select-color' ).on('click', function(e){
        if( e.target == this ||  e.target == $('.priceWrp') ) { 
            $(this).addClass('badTouch');
    } else {
        $(this).removeClass('badTouch');
    }
    });
    $('#prodContDtls .select-color' ).on('mouseleave', function(){
        $(this).removeClass('badTouch');
    });*/

    //sort filter legacy
    $("#catSortCategories a").click(function(e) {
        e.preventDefault();
        var theProdUrl
        if ($('#catSortProductType a.cur').length) {
            theProdUrl = $('#catSortProductType a.cur').attr('href');
        } else {
            theProdUrl = '/all/'
        }
        var theTag = $(this).attr('href');
        window.location.href = '/collections' + theProdUrl + theTag
    });

    //mobile sidebar toggle
    $('body').on('click', '.menuToggle', function() {
        $('body').toggleClass('sidebarOpen');
    });
    /*============================================================================
      Load More Search items
    ==============================================================================*/
    /*
    var enableLoadMoreSearch = function(){
        $('body').on('click', '.js-load-more a', function(e){
          enableInfiniteSearchScroll();
          e.stopPropagation();
          return false;
        });
      }
      
      var enableInfiniteSearchScroll = function(){
        if ($('.search-matrix').length) {
          var infiniteSearchScroll = new Waypoint.Infinite({
            element: $('.search-matrix')[0],
            items: '.search-matrix',
            more: '.load-more__btn',
            loadingClass: 'loading-in-progress',
            onBeforePageLoad: function(){
              $('.js-load-more').hide();
            },
            onAfterPageLoad: function(data){
              
              
                convertCurrencies();
              
            }
          })
        }
      }
      */
    /*============================================================================
      Load More Products
    ==============================================================================*/

    // var enableLoadMoreProducts = function(){
    /*$('body').on('click', '.js-load-more a', function(e){
      enableInfiniteScroll();
      e.stopPropagation();
      return false;
    });*/
    //}


    /*var enableInfiniteScroll = function(){
      if ($('.collection-matrix').length) {
        var infiniteScroll = new Waypoint.Infinite({
          element: $('.collection-matrix')[0],
          items: '.prodItm',
          more: '.load-more__btn',
          loadingClass: 'loading-in-progress',
          offset: 'bottom-in-view',
          onBeforePageLoad: function(){
           // $('.js-load-more').hide();
           // console.log('before')
           //$('#filterProdLst').addClass('filterIsLoading');

          },
          onAfterPageLoad: function(data){
             // $('#filterProdLst').removeClass('filterIsLoading');
            //console.log('more')
              //convertCurrencies();
            //  Waypoint.refreshAll();
          }
        })
      }
    }*/
    //enableInfiniteScroll();

    /*============================================================================
  Sidebar filter on collection pages
==============================================================================*/

    var collectionSidebarFilter = {
        init: function() {
            //$('.filter-active-tag input:checked').parents('.filter-active-tag').siblings('.filter-all-tags').hide();
            var curVal = $('.filter-active-tag input:checked').val();
            $('.filter-active-tag input:checked').parents('.filter-active-tag').siblings('.filter-all-tags').find('input[value=' + curVal + ']').parents('a').addClass('active');
            //$('.toggle-all--true .toggle_list .filter-active-tag input:checked').parents('ul.toggle_list').prev().click();

            //Hide filters if types or vendors is in URL (can't be combined)
            if ($.url(2) === 'types' || $.url(2) === 'vendors') {
                $('.sidebar__collection-filter').remove();
            }

            $('.sidebar-block:empty').prev().css('border-bottom', 'none');

        },
        clearAllFilters: function() {
            $('[data-option-filter] input').attr('checked', false);
            $('[data-option-filter] input').trigger('change');
        },
        clearSelectedFilter: function(optionFilter) {
            optionFilter.find('[data-option-filter] input').attr('checked', false);
            optionFilter.find('[data-option-filter] input').trigger('change');
        }
    }

    //Check the checkbox values
    $('body').on('change', '[data-option-filter] input', function(e) {
        e.preventDefault();
        tempTagsArr = []
        selectedOptions = []
        quickFilter.init();
        /*$("html, body").animate({
          scrollTop: ($('#pagecontent').offset().top)
        }, 500);*/
    })

    $('body').on('click', '[data-reset-filters]', function() {
        collectionSidebarFilter.clearAllFilters();
    });

    $('body').on('click', '[data-clear-filter]', function() {
        var selectedOption = $(this).parents('.filter-active-tag');
        collectionSidebarFilter.clearSelectedFilter(selectedOption);
    });
    // new by categories menu filter
    $('body').on('click', '.filterMenu a', function(e) {
        e.preventDefault();
        if (!$(this).is('.active')) {
            $(this).parents('.filterMenu').find('.active').removeClass('active');
            // $('.filterMenu a').removeClass('active');
            $('.catall').removeClass('catall');
            $(this).addClass('active');
            //slide up if not t-shirt styles anymore
            if (!$('.filterMenuProductsMenu .t-shirts a.active').length) {
                $('.filterMenuTShirtStyles').parent().fadeOut(250);
            }

            //if($(this).parents('.filterMenuTShirtStyles').length){
            //  $('.filterMenuProductsMenu .t-shirts a').addClass('active');
            // }
            thePath = $(this).attr('href') + '/';
            tempPath = thePath
            tempProd = $(this).html().toLowerCase();
            quickFilter.processUrl(thePath, tempTags, tempQuery);
        }
    });
    /*============================================================================
      Filter Products with AJAX
    ==============================================================================*/
    //https://famousinreal.life/collections/television-men-unisex-apparel

    Shopify.queryParams = {};
    if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }
    var tempPath
    var currentTags = '';
    var tempProd = $('.filterMenuProductsMenu a.active').attr('title');
    var tempTags = '';
    var tempTagsArr = []
    var tempQuery = '';
    var loopcheck = true
    var selectedOptions = []
    /*var quickFilter = {
      init: function(firstInit){
         selectedOptions = [],
            query = '',
            currentTags = '',
            siteUrl = 'https://' + $.url('hostname'),
            url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
            url2 = $.url('2') ? $.url('2') + '/' : '',
            url3 = $.url('3'),
            path = url1 + url2;
            console.log(selectedOptions)
            selectedOptions = []
            console.log(selectedOptions)
        //Handle dropdowns if they exist
        if ($('#sort-by').length){
          query = $('#sort-by').val();
        } else {
          query = url('?sort_by');
        }
       //reset sort by
       query = ''
        if ($('#tag_filter').length){
    
          if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
            urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);
            if (urlTag != 'all'){
              if ($.inArray( urlTag, selectedOptions ) > -1){
                //Do nothing
              } else {
              console.log(selectedOptions)
                //selectedOptions.unshift(urlTag);
                console.log(selectedOptions)
              }
            }
          }
        }
    
        //Add all checkbox values to array
        $('[data-option-filter] input').each(function (){
            console.log('checking selected options')
          if ($(this).prop("checked") == true) {
              selectedOptions.push($(this).val());
              console.log('checkoptions',selectedOptions)
          }
        });
        selectedOptions = $.makeArray(selectedOptions);

        var uniq = selectedOptions.reduce(function(a,b){
          if (a.indexOf(b) < 0 ) a.push(b);
          return a;
        },[]);
        selectedOptions = uniq
        tempTagsArr = selectedOptions
        //Loop through tags to create string to update page url
        $.each(selectedOptions, function(i, value){
    
          if (i != selectedOptions.length - 1) {
            currentTags += selectedOptions[i] + '+';
          } else {
            currentTags += selectedOptions[i];
          }
          tempTags = currentTags
        });
    
        Shopify.queryParams.sort_by = query;
        query = '?' + $.param(Shopify.queryParams);
        tempQuery = query; 
        if(!firstInit) {
          quickFilter.processUrl(path, currentTags, query);
        }
      },
      updateView: function(filterURL) {
     console.log('updating view');
        $.ajax({
           type: 'GET',
           url: filterURL,
           beforeSend: function() {
              $(".collection-matrix").addClass('fadeOut animated loading-in-progress filter-loading');
              $("#filterProdLst").addClass('filterIsLoading');
              //Waypoint.destroyAll();
              var filterProd = tempProd
              filterProd = filterProd.replace('All', 'all');
              filterProd = filterProd.replace('short sleeve', 't-shirts');
              filterProd = filterProd.replace('long sleeve', 't-shirts');
              filterProd = filterProd.replace("3\/4 sleeve baseball", 't-shirts');
              filterProd = filterProd.replace('kids', 't-shirts');
              //update the top banner
              if (typeof tempTagsArr[0] === 'undefined'){
                  if(filterProd && filterProd != 'all' ) { 
                     $('#innerSmlIntroCont .genTitle2').html(filterProd);
                      $('#innerSmlIntroSection').removeAttr('class').addClass('collectionBg-all')
                   } else {
                   $('#innerSmlIntroCont .genTitle2').html('Products');
                    $('#innerSmlIntroSection').removeAttr('class').addClass('collectionBg-all')
                   }
                } else {
                  console.log('tempprod=',tempProd)
                  var filterTag = tempTagsArr[0]
                  filterTag = filterTag.replace('vegas', 'Vintage Las Vegas');
                  filterTag = filterTag.replace('tiki-bars', 'Vintage Tiki Bars');
                  filterTag = filterTag.replace('rr_track_bowlingalley', 'Vintage Bowling Alley');
                  filterTag = filterTag.replace('patty', 'St.Patrick\'s Day');
                  filterTag = filterTag.replace('4th', '4th of July');
                  if(filterProd && filterProd != 'all' ) { 
                      filterTag = filterTag.replace('Vintage Tiki Bars', 'Vintage Tiki Bar');
                      filterTag = filterTag.replace('movies', 'movie');
                      $('#innerSmlIntroCont .genTitle2').html(filterTag+' '+filterProd);
                      $('#innerSmlIntroSection').removeAttr('class').addClass('collectionBg-'+tempTagsArr[0])
                   } else {
         
                    $('#innerSmlIntroCont .genTitle2').html(filterTag);
                    $('#innerSmlIntroSection').removeAttr('class').addClass('collectionBg-'+tempTagsArr[0])
                   }
                }
           },
           success: function(data) {
               if ($(data).find('#noproducts').length) {
                   console.log('noprods')
              if(loopcheck) {
                  loopcheck = false
              //search again without filter
              quickFilter.processUrl(tempPath, '', '');
              tempTags = ''
              }
              } else {  
              loopcheck = true
              $(".collection-matrix").removeClass('loading-in-progress');
              $(".collection-matrix").removeClass('filter-loading');
              $("#filterProdLst").removeClass('filterIsLoading');
              //var filteredBreadcrumb = $(data).find('.breadcrumb_text').html();
              //$('.breadcrumb_text').html(filteredBreadcrumb);
    
              var filteredPagination = $(data).find('.paginate').html();
              $('.paginate').html(filteredPagination);
              var filteredSidebar = $(data).find('.sidebar').html();
              var prodHeadingTag = $(data).find('.filter-all-tags').find('a.active').attr('title'); 
              var prodHeadingType = $(data).find('.filterMenuProductsMenu').find('a.active').attr('title'); 

            

              if (typeof prodHeadingTag !== "undefined") {
                  prodHeadingTag = prodHeadingTag.replace('vegas', 'Vintage Las Vegas');
                  prodHeadingTag = prodHeadingTag.replace('tiki-bars', 'Vintage Tiki Bars');
                  prodHeadingTag = prodHeadingTag.replace('rr_track_bowlingalley', 'Vintage Bowling Alley');
                  prodHeadingTag = prodHeadingTag.replace('patty', 'St.Patrick\'s Day');
                  prodHeadingTag = prodHeadingTag.replace('4th', '4th of July');
                  prodHeadingTag = prodHeadingTag.toLowerCase(); 
              } else {
                  prodHeadingTag = 'all'
              }
              if (typeof prodHeadingType !== "undefined") {
                  prodHeadingType = prodHeadingType.toLowerCase(); 
              } else {
                  prodHeadingType = 'all'
              }
              var prodHeading = ''
              if(prodHeadingTag == 'all' && prodHeadingType == 'all' ) {
                  prodHeading = 'Products';
              } else if ( prodHeadingTag == 'all' ) {
                  prodHeading = prodHeadingType;
              } else if ( prodHeadingType == 'all') {
                  prodHeading = prodHeadingTag;
              }  else {
                  prodHeading = prodHeadingTag +' '+prodHeadingType;
                  prodHeading = prodHeading.replace('vintage tiki bars','vintage tiki bar');
                  prodHeading = prodHeading.replace('movies','movie');      
              }
              $('#innerSmlIntroCont .genTitle2').html(prodHeading);
              $('.sidebar').html(filteredSidebar);
    
              var filteredPageLinks = $(data).find('.paginate').html();
              $('.paginate').empty();
              $('.paginate').html(filteredPageLinks);
    
              var filteredData = $(data).find('.collection-matrix');
              $('.collection-matrix').remove();
              filteredData.insertBefore( $('.load-more__icon') );
              window.history && window.history.pushState && window.history.pushState("", "", filterURL);
    
              if ($('.sidebar__collection-filter').length){
                collectionSidebarFilter.init();
              }
              }

                //convertCurrencies();
                //enableInfiniteScroll();
              
           },
           error: function(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
            location.replace(location.protocol + '://' + location.host + filterURL);
    
           },
           dataType: "html"
        });
      },
      processUrl: function(path, tags, query){
     console.log('checkit', path,tags, query)
        var query = query.replace(/\page=(\w+)&/, ''),
            urlString = '';
    
        urlString = path + tags + query;
        tempTags = tags //maybe wrong
        quickFilter.updateView(urlString);
      }
    }*/

    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body').on('change', '#tag_filter, #sort-by', function() {
        //quickFilter.init();
    });

    $('body').on('change', '#blog_filter', function() {
        var url = $(this).val();
        window.location = url;
    });
    //init onload to get url params
    //quickFilter.init(true);
    $('input, select, textarea').on('focus blur', function(event) {
        $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
    });
    $('body').on('transitionstart', '.omega__autocomplete', function() {
        if ($('.omega__empty-result:visible').length) {
            $('.omega__autocomplete').parent().removeClass('showSearch').addClass('hideSearch');
        } else {
            $('.omega__autocomplete').parent().removeClass('hideSearch').addClass('showSearch');
        }
    });

    //recover password fire lightbox
    if (window.location.hash) {
        var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
        if (hash == 'recover') {
            fireModal('/account/login')
        }
        // hash found
    }
    //toggle
    $('body').on('click', 'a[data-toggle]', function(e) {
        e.preventDefault();
        var toggleId = $(this).attr('data-toggle');
        $('.toggle:visible').slideUp('300');
        $('#' + toggleId).slideDown('300');
    });
    if (typeof $.validator != 'undefined') {
            var captchaValid 
            captchaSet = function(response) {
            console.log(response);
		    captchaValid = true
        };
        //cadd check captcha to jqvalidate for ajax
        $.validator.addMethod("checkCaptcha", (function() {
            $.validator.messages["checkCaptcha"] = "Captcha verification required";
            return captchaValid;
        }), '' );
        // validate function
        function validateForm(element) {
            //check bot
            $(element).validate({
                ignore: [], //don't ignore hidden
                highlight: function(element) {
                    $(element).parent().addClass("error");
                    $(element).addClass("error");
                },
                unhighlight: function(element) {
                    $(element).parent().removeClass("error");
                    $(element).removeClass("error");
                },
                onfocusout: function(element, event) {
                    this.element(element);
                },
                invalidHandler: function(event, validator) {
                    console.log('stopping')
                    console.log(validator.errorList); 
                    event.stopPropagation();
                    event.preventDefault();
                    return false;
                    //validator.errorList contains an array of objects, where each object has properties "element" and "message".  element is the actual HTML Input.
                    //var fullErr = ''
                    /* error_handler(validator.errorMap);*/
                },
                errorClass: 'error',
                errorElement: 'small',
                errorPlacement: function(error, element) {
                    var theEl = element.parent();
                    if (element.parent('span').length) {
                        theEl = element.parent().parent();
                    }
                    error.appendTo(theEl);
                },
                //onkeyup: false,
                // other rules and options
                rules: {
                    name: "required",
                    email: {
                        email: true
                    },
                    "g-recaptcha-response": {
                        checkCaptcha: true
                  }
                },
                submitHandler: function(form, event) {
                    console.log('submit')
                    event.preventDefault();
                    //form.submit(); 
                }
            });
        }

        $('.jQvalidate form, form.validate, .validate form').each(function(i, theEl) {
            //shopify app issues fix
            $(' .validate').on('click', '.genBtn1', function(e) {
                if (!$('.validate form').valid()) {
                    e.stopPropagation();
                    e.preventDefault();
                }
            });
            validateForm(theEl);
        });
    }
    if(window.location.href.indexOf("challenge") > -1 && ($('.shopify-challenge__container form').attr('action') == 'https://www.m00nshot.com/account/recover') ) {
            $('.shopify-challenge__container form').prepend('<input type="hidden" name="return_to" value="/pages/password-reset-confirmation">'); 
     };


 //disable  size select on landing (heather swap + price update doesn't work unless option selected)
 /*var params = new URLSearchParams(document.location.search);
 var isVariantId = params.get("variant");
if(  !isVariantId  ) {

    $('.select-size input').prop('checked', false);
    $('button[data-add-to-cart]').attr('disabled',true);
    //$('select[name="id"]').find($('option')).attr('selected',false).trigger('change');
    $('#prodOptionBlock').on('mousedown', '.buttonDisabled', function(e){
        e.preventDefault();
        alert('Choose your size before adding to cart.');
       });
}*/

});

/* 
////
//// On History Back issue fix
////
--------------------------------------------------------------*/
/*$(window).on('popstate', function (e) {
    console.log('back');
    var state = e.originalEvent.state;
    console.log(state);
    if (state !== null) {
        $('input, textarea').each(function () {
            console.log('fillval',$(this).attr('name') , $(this).val()  )
            if ($(this).val() != '') {
                $(this).addClass('inputHasVal');
            }
        });
    }
});*/